<div [ngClass]="{ 'dark text-white-dark': store.semidark }">
    <nav class="sidebar fixed bottom-0 top-0 z-50 h-full min-h-screen w-[260px] shadow-[5px_0_25px_0_rgba(94,92,154,0.1)] transition-all duration-300">
        <div class="h-full bg-white dark:bg-[#0e1726]">
            <div class="flex items-center justify-between px-4 py-3">
                <a routerLink="/" class="main-logo flex shrink-0 items-center">
                    <img class="ml-[5px] w-20 flex-none" src="{{logo}}" alt="" style="width: 150px" />
                </a>
                <a
                    href="javascript:;"
                    class="collapse-icon flex h-8 w-8 items-center rounded-full transition duration-300 hover:bg-gray-500/10 hover:text-primary dark:text-white-light dark:hover:bg-dark-light/10 rtl:rotate-180"
                    (click)="storeData.dispatch({ type: 'toggleSidebar'})"
                >
                    <icon-carets-down class="m-auto rotate-90"></icon-carets-down>
                </a>
            </div>
            <ng-scrollbar class="relative !h-[calc(100vh-80px)]" appearance="compact">
                <ul class="relative space-y-0.5 mt-3 p-4 py-0 font-semibold">
                    <li class="nav-item" *ngFor="let item of menuItems">
                        <div *ngIf="!item.subItems || item.subItems.length === 0">
                            <a routerLink="{{ item.link }}" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                                <div class="flex items-center pl-3">
                                    <ng-container *ngIf="item.icon">
                                        <ng-container *ngComponentOutlet="getIconComponent(item.icon)"></ng-container>
                                    </ng-container>
                                    <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">
                                        {{ item.label }}
                                    </span>
                                </div>
                            </a>
                        </div>
                        <ng-container *ngIf="item.subItems && item.subItems.length > 0">
                            <h2 class="-mx-4 mb-1 flex items-center bg-white-light/30 px-7 py-3 font-extrabold uppercase dark:bg-dark dark:bg-opacity-[0.08]">
                                <ng-container *ngIf="item.icon">
                                    <ng-container *ngComponentOutlet="getIconComponent(item.icon)"></ng-container>
                                </ng-container>
                                <span>{{ (item.label) || '&nbsp;' }}</span>
                            </h2>
                            <ul>
                                <li class="nav-item" *ngFor="let subItem of item.subItems">
                                    <a routerLink="{{ subItem.link }}" class="group" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="toggleMobileMenu()">
                                        <div class="flex items-center">
                                            <ng-container *ngIf="subItem.icon">
                                                <ng-container *ngComponentOutlet="getIconComponent(subItem.icon)"></ng-container>
                                            </ng-container>
                                            <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">
                                                {{ subItem.label }}
                                            </span>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </ng-container>
                    </li>
                </ul>
            </ng-scrollbar>
        </div>
    </nav>
</div>
